const lingkSpecificKeywords = [
  { label: 'EXECUTE', type: 'keyword' },
  { label: 'PRINT', type: 'keyword' },
  { label: 'DELETE', type: 'keyword' },
  { label: 'INSERT', type: 'keyword' },
  { label: 'UPDATE', type: 'keyword' },
  { label: 'PRINT SCHEMA', type: 'keyword' },
  { label: 'REFRESH', type: 'keyword' },
  { label: 'SLEEP', type: 'keyword' },
  { label: 'STOP', type: 'keyword' },
  { label: 'STOPIFZERO', type: 'keyword' },
  { label: 'VALIDATE', type: 'keyword' },
];
const additionalKeywords = [
  // Transaction Control
  { label: 'BEGIN', type: 'keyword', info: 'Starts a transaction' },
  { label: 'COMMIT', type: 'keyword', info: 'Commits current transaction' },
  { label: 'ROLLBACK', type: 'keyword', info: 'Rolls back current transaction' },
  { label: 'SAVEPOINT', type: 'keyword', info: 'Creates a savepoint within transaction' },
  { label: 'SET TRANSACTION', type: 'keyword', info: 'Sets transaction properties' },

  // Missing DML Operations
  { label: 'UPDATE', type: 'keyword', info: 'Updates data in a table' },
  { label: 'DELETE', type: 'keyword', info: 'Deletes data from a table' },
  { label: 'MERGE', type: 'keyword', info: 'Merges data into a table (upsert)' },

  // Constraints
  { label: 'PRIMARY KEY', type: 'keyword', info: 'Defines primary key constraint' },
  { label: 'FOREIGN KEY', type: 'keyword', info: 'Defines foreign key constraint' },
  { label: 'UNIQUE', type: 'keyword', info: 'Defines unique constraint' },
  { label: 'CHECK', type: 'keyword', info: 'Defines check constraint' },
  { label: 'NOT NULL', type: 'keyword', info: 'Defines not null constraint' },
  { label: 'DEFAULT', type: 'keyword', info: 'Defines default value' },

  // Join Types
  { label: 'INNER JOIN', type: 'keyword', info: 'Joins matching rows from both tables' },
  { label: 'LEFT JOIN', type: 'keyword', info: 'Joins all rows from left table' },
  { label: 'LEFT OUTER JOIN', type: 'keyword', info: 'Synonym for LEFT JOIN' },
  { label: 'RIGHT JOIN', type: 'keyword', info: 'Joins all rows from right table' },
  { label: 'RIGHT OUTER JOIN', type: 'keyword', info: 'Synonym for RIGHT JOIN' },
  { label: 'FULL JOIN', type: 'keyword', info: 'Joins all rows from both tables' },
  { label: 'FULL OUTER JOIN', type: 'keyword', info: 'Synonym for FULL JOIN' },
  { label: 'CROSS JOIN', type: 'keyword', info: 'Cartesian product of tables' },
  { label: 'NATURAL JOIN', type: 'keyword', info: 'Joins on columns with same name' },

  // Additional Clauses
  { label: 'WITH', type: 'keyword', info: 'Defines common table expression (CTE)' },
  { label: 'OVER', type: 'keyword', info: 'Defines window for window functions' },
  { label: 'PARTITION BY', type: 'keyword', info: 'Divides result into partitions' },
  { label: 'GRANT', type: 'keyword', info: 'Grants permissions' },
  { label: 'REVOKE', type: 'keyword', info: 'Revokes permissions' },
  { label: 'BETWEEN', type: 'keyword', info: 'Checks if value is within range' },
  { label: 'IN', type: 'keyword', info: 'Checks if value matches any in a list' },
  { label: 'EXISTS', type: 'keyword', info: 'Checks if subquery returns results' },
  { label: 'ALL', type: 'keyword', info: 'Returns true if all subquery values meet condition' },
  { label: 'ANY', type: 'keyword', info: 'Returns true if any subquery value meets condition' },
  { label: 'SOME', type: 'keyword', info: 'Synonym for ANY' },

  // Aggregate Functions
  { label: 'SUM', type: 'keyword', info: 'Calculates sum of values' },
  { label: 'COUNT', type: 'keyword', info: 'Counts rows or non-null values' },
  { label: 'AVG', type: 'keyword', info: 'Calculates average of values' },
  { label: 'MIN', type: 'keyword', info: 'Finds minimum value' },
  { label: 'MAX', type: 'keyword', info: 'Finds maximum value' },

  // String Functions
  { label: 'CONCAT', type: 'keyword', info: 'Concatenates strings' },
  { label: 'SUBSTRING', type: 'keyword', info: 'Extracts part of a string' },
  { label: 'TRIM', type: 'keyword', info: 'Removes leading/trailing characters' },
  { label: 'UPPER', type: 'keyword', info: 'Converts to uppercase' },
  { label: 'LOWER', type: 'keyword', info: 'Converts to lowercase' },
  { label: 'LENGTH', type: 'keyword', info: 'Returns length of string' },

  // Date Functions
  { label: 'CURRENT_DATE', type: 'keyword', info: 'Returns current date' },
  { label: 'CURRENT_TIME', type: 'keyword', info: 'Returns current time' },
  { label: 'CURRENT_TIMESTAMP', type: 'keyword', info: 'Returns current timestamp' },
  { label: 'EXTRACT', type: 'keyword', info: 'Extracts part from date/time' },
  { label: 'DATE_ADD', type: 'keyword', info: 'Adds interval to date' },
  { label: 'DATE_SUB', type: 'keyword', info: 'Subtracts interval from date' },

  // Conversion Functions
  { label: 'CAST', type: 'keyword', info: 'Converts data type' },
  { label: 'CONVERT', type: 'keyword', info: 'Converts data type' },

  // Additional clauses
  { label: 'IS NULL', type: 'keyword', info: 'Checks if value is null' },
  { label: 'IS NOT NULL', type: 'keyword', info: 'Checks if value is not null' },
  { label: 'LIKE', type: 'keyword', info: 'Pattern matching with wildcards' },
  { label: 'REGEXP', type: 'keyword', info: 'Pattern matching with regular expressions' },
  { label: 'CASE', type: 'keyword', info: 'Conditional logic' },
  { label: 'WHEN', type: 'keyword', info: 'Condition in CASE statement' },
  { label: 'THEN', type: 'keyword', info: 'Result in CASE statement' },
  { label: 'ELSE', type: 'keyword', info: 'Default in CASE statement' },
  { label: 'END', type: 'keyword', info: 'Ends CASE statement' },
];
export const keywords = [
  { label: 'ALTER DATABASE', type: 'keyword', info: 'Modifies database properties' },
  { label: 'ALTER SCHEMA', type: 'keyword', info: 'Modifies schema properties' },
  { label: 'ALTER TABLE', type: 'keyword', info: 'Modifies table structure' },
  { label: 'ALTER VIEW', type: 'keyword', info: 'Modifies view definition' },
  { label: 'CREATE DATABASE', type: 'keyword', info: 'Creates a new database' },
  { label: 'CREATE SCHEMA', type: 'keyword', info: 'Creates a new schema' },
  { label: 'CREATE FUNCTION', type: 'keyword', info: 'Creates a new function' },
  { label: 'CREATE TEMPORARY FUNCTION', type: 'keyword', info: 'Creates a temporary function' },
  { label: 'CREATE TABLE', type: 'keyword', info: 'Creates a new table' },
  { label: 'CREATE VIEW', type: 'keyword', info: 'Creates a new view' },
  { label: 'DROP DATABASE', type: 'keyword', info: 'Removes a database' },
  { label: 'DROP SCHEMA', type: 'keyword', info: 'Removes a schema' },
  { label: 'DROP FUNCTION', type: 'keyword', info: 'Removes a function' },
  { label: 'DROP TEMPORARY FUNCTION', type: 'keyword', info: 'Removes a temporary function' },
  { label: 'DROP TABLE', type: 'keyword', info: 'Removes a table' },
  { label: 'DROP VIEW', type: 'keyword', info: 'Removes a view' },
  { label: 'MSCK REPAIR TABLE', type: 'keyword', info: 'Repairs table metadata' },
  { label: 'TRUNCATE TABLE', type: 'keyword', info: 'Removes all rows from a table' },
  { label: 'USE', type: 'keyword', info: 'Selects a database context' },
  { label: 'INSERT INTO', type: 'keyword', info: 'Inserts data into a table' },
  { label: 'INSERT OVERWRITE', type: 'keyword', info: 'Overwrites data in a table' },
  { label: 'INSERT OVERWRITE DIRECTORY', type: 'keyword', info: 'Overwrites data in a directory' },
  { label: 'LOAD DATA', type: 'keyword', info: 'Loads data into a table' },
  { label: 'SELECT', type: 'keyword', info: 'Retrieves data from tables' },
  { label: 'CLUSTER BY', type: 'keyword', info: 'Groups data by columns' },
  { label: 'DISTRIBUTE BY', type: 'keyword', info: 'Distributes data across reducers' },
  { label: 'GROUP BY', type: 'keyword', info: 'Groups rows that have the same values' },
  { label: 'HAVING', type: 'keyword', info: 'Specifies conditions for grouped rows' },
  { label: 'INLINE TABLE', type: 'keyword', info: 'Creates an inline table' },
  { label: 'FILE', type: 'keyword', info: 'Specifies a file operation' },
  { label: 'JOIN', type: 'keyword', info: 'Combines rows from multiple tables' },
  { label: 'LIKE', type: 'keyword', info: 'Pattern matching operator' },
  { label: 'LIMIT', type: 'keyword', info: 'Limits the number of rows returned' },
  { label: 'ORDER BY', type: 'keyword', info: 'Sorts the result set' },
  { label: 'SET OPERATORS', type: 'keyword', info: 'Combines multiple queries' },
  { label: 'SORT BY', type: 'keyword', info: 'Sorts data within each reducer' },
  { label: 'TABLESAMPLE', type: 'keyword', info: 'Samples a subset of data' },
  { label: 'range', type: 'keyword', info: 'Generates a sequence of numbers' },
  { label: 'explode', type: 'keyword', info: 'Creates a row for each element in an array' },
  { label: 'explode_outer', type: 'keyword', info: 'Outer version of explode' },
  { label: 'inline', type: 'keyword', info: 'Expands array of structs into a table' },
  { label: 'inline_outer', type: 'keyword', info: 'Outer version of inline' },
  { label: 'posexplode', type: 'keyword', info: 'Explode with position information' },
  { label: 'posexplode_outer', type: 'keyword', info: 'Outer version of posexplode' },
  { label: 'stack', type: 'keyword', info: 'Converts columns to rows' },
  { label: 'json_tuple', type: 'keyword', info: 'Returns tuple from JSON string' },
  { label: 'parse_url', type: 'keyword', info: 'Parses URL components' },
  { label: 'WHERE', type: 'keyword', info: 'Specifies conditions for filtering rows' },
  { label: 'WINDOW FUNCTION', type: 'keyword', info: 'Performs calculations across rows' },
  { label: 'CASE', type: 'keyword', info: 'Conditional expression' },
  { label: 'PIVOT', type: 'keyword', info: 'Converts rows to columns' },
  { label: 'LATERAL VIEW', type: 'keyword', info: 'Generates virtual table' },
  { label: 'EXPLAIN', type: 'keyword', info: 'Shows query execution plan' },
  { label: 'ADD FILE', type: 'keyword', info: 'Adds a file to distributed cache' },
  { label: 'ADD JAR', type: 'keyword', info: 'Adds a JAR to distributed cache' },
  { label: 'ANALYZE TABLE', type: 'keyword', info: 'Analyzes table statistics' },
  { label: 'CACHE TABLE', type: 'keyword', info: 'Caches table in memory' },
  { label: 'CACHE LAZY TABLE', type: 'keyword', info: 'Lazily caches table' },
  { label: 'CLEAR CACHE', type: 'keyword', info: 'Clears the cache' },
  { label: 'DESCRIBE DATABASE', type: 'keyword', info: 'Shows database metadata' },
  { label: 'DESC DATABASE', type: 'keyword', info: 'Shows database metadata' },
  { label: 'DESCRIBE FUNCTION', type: 'keyword', info: 'Shows function details' },
  { label: 'DESC FUNCTION', type: 'keyword', info: 'Shows function details' },
  { label: 'DESCRIBE QUERY', type: 'keyword', info: 'Shows query details' },
  { label: 'DESC QUERY', type: 'keyword', info: 'Shows query details' },
  { label: 'DESCRIBE TABLE', type: 'keyword', info: 'Shows table metadata' },
  { label: 'DESC TABLE', type: 'keyword', info: 'Shows table metadata' },
  { label: 'LIST FILE', type: 'keyword', info: 'Lists files in cache' },
  { label: 'LIST JAR', type: 'keyword', info: 'Lists JARs in cache' },
  { label: 'REFRESH', type: 'keyword', info: 'Refreshes metadata' },
  { label: 'REFRESH TABLE', type: 'keyword', info: 'Refreshes table metadata' },
  { label: 'RESET', type: 'keyword', info: 'Resets configurations' },
  { label: 'SET', type: 'keyword', info: 'Sets configurations' },
  { label: 'SHOW COLUMNS', type: 'keyword', info: 'Shows table columns' },
  { label: 'SHOW CREATE TABLE', type: 'keyword', info: 'Shows table creation statement' },
  { label: 'SHOW DATABASES', type: 'keyword', info: 'Lists all databases' },
  { label: 'SHOW FUNCTIONS', type: 'keyword', info: 'Lists available functions' },
  { label: 'SHOW SYSTEMFUNCTIONS', type: 'keyword', info: 'Lists system functions' },
  { label: 'SHOW PARTITIONS', type: 'keyword', info: 'Shows table partitions' },
  { label: 'SHOW TABLE EXTENDED', type: 'keyword', info: 'Shows detailed table info' },
  { label: 'SHOW TABLES', type: 'keyword', info: 'Lists all tables' },
  { label: 'SHOW TBLPROPERTIES', type: 'keyword', info: 'Shows table properties' },
  { label: 'SHOW VIEWS', type: 'keyword', info: 'Lists all views' },
  { label: 'UNCACHE TABLE', type: 'keyword', info: 'Removes table from cache' },
  { label: 'STATISTICS', type: 'keyword', info: 'Table statistics' },
  { label: 'NOSCAN', type: 'keyword', info: 'Skips table scanning' },
  { label: 'COMPUTE', type: 'keyword', info: 'Computes statistics' },
  { label: 'COMPUTE STATISTICS', type: 'keyword', info: 'Computes table statistics' },
  {
    label: 'COMPUTE STATISTICS NOSCAN',
    type: 'keyword',
    info: 'Computes statistics without scanning',
  },
  { label: 'storageLevel', type: 'keyword', info: 'Specifies storage level' },
  { label: 'NONE', type: 'keyword', info: 'No persistence' },
  { label: 'DISK_ONLY', type: 'keyword', info: 'Persist on disk only' },
  { label: 'DISK_ONLY_2', type: 'keyword', info: 'Persist on disk with replication' },
  { label: 'MEMORY_ONLY', type: 'keyword', info: 'Persist in memory only' },
  { label: 'MEMORY_ONLY_2', type: 'keyword', info: 'Persist in memory with replication' },
  { label: 'MEMORY_ONLY_SER', type: 'keyword', info: 'Persist serialized in memory' },
  {
    label: 'MEMORY_ONLY_SER_2',
    type: 'keyword',
    info: 'Persist serialized in memory with replication',
  },
  { label: 'MEMORY_AND_DISK', type: 'keyword', info: 'Persist in memory and disk' },
  {
    label: 'MEMORY_AND_DISK_2',
    type: 'keyword',
    info: 'Persist in memory and disk with replication',
  },
  { label: 'MEMORY_AND_DISK_SER', type: 'keyword', info: 'Persist serialized in memory and disk' },
  {
    label: 'MEMORY_AND_DISK_SER_2',
    type: 'keyword',
    info: 'Persist serialized in memory and disk with replication',
  },
  { label: 'OFF_HEAP', type: 'keyword', info: 'Persist off heap' },
  ...additionalKeywords,
  ...lingkSpecificKeywords,
];

export const snippets = [
  {
    label: 'adb',
    type: 'text',
    apply: 'ALTER DATABASE',
    detail: 'macro',
    info: 'ALTER DATABASE keyword for modifying database properties',
  },
  {
    label: 'asch',
    type: 'text',
    apply: 'ALTER SCHEMA',
    detail: 'macro',
    info: 'ALTER SCHEMA keyword for modifying schema properties',
  },
  {
    label: 'at',
    type: 'text',
    apply: 'ALTER TABLE',
    detail: 'macro',
    info: 'ALTER TABLE keyword for modifying table structure',
  },
  {
    label: 'av',
    type: 'text',
    apply: 'ALTER VIEW',
    detail: 'macro',
    info: 'ALTER VIEW keyword for modifying view definition',
  },
  {
    label: 'cdb',
    type: 'text',
    apply: 'CREATE DATABASE',
    detail: 'macro',
    info: 'CREATE DATABASE keyword for creating a new database',
  },
  {
    label: 'csch',
    type: 'text',
    apply: 'CREATE SCHEMA',
    detail: 'macro',
    info: 'CREATE SCHEMA keyword for creating a new schema',
  },
  {
    label: 'cf',
    type: 'text',
    apply: 'CREATE FUNCTION',
    detail: 'macro',
    info: 'CREATE FUNCTION keyword for creating a new function',
  },
  {
    label: 'ctf',
    type: 'text',
    apply: 'CREATE TEMPORARY FUNCTION',
    detail: 'macro',
    info: 'CREATE TEMPORARY FUNCTION keyword for creating a temporary function',
  },
  {
    label: 'ct',
    type: 'text',
    apply: 'CREATE TABLE',
    detail: 'macro',
    info: 'CREATE TABLE keyword for creating a new table',
  },
  {
    label: 'cv',
    type: 'text',
    apply: 'CREATE VIEW',
    detail: 'macro',
    info: 'CREATE VIEW keyword for creating a new view',
  },
  {
    label: 'ddb',
    type: 'text',
    apply: 'DROP DATABASE',
    detail: 'macro',
    info: 'DROP DATABASE keyword for removing a database',
  },
  {
    label: 'dsch',
    type: 'text',
    apply: 'DROP SCHEMA',
    detail: 'macro',
    info: 'DROP SCHEMA keyword for removing a schema',
  },
  {
    label: 'df',
    type: 'text',
    apply: 'DROP FUNCTION',
    detail: 'macro',
    info: 'DROP FUNCTION keyword for removing a function',
  },
  {
    label: 'dtf',
    type: 'text',
    apply: 'DROP TEMPORARY FUNCTION',
    detail: 'macro',
    info: 'DROP TEMPORARY FUNCTION keyword for removing a temporary function',
  },
  {
    label: 'dt',
    type: 'text',
    apply: 'DROP TABLE',
    detail: 'macro',
    info: 'DROP TABLE keyword for removing a table',
  },
  {
    label: 'dv',
    type: 'text',
    apply: 'DROP VIEW',
    detail: 'macro',
    info: 'DROP VIEW keyword for removing a view',
  },
  {
    label: 'mrt',
    type: 'text',
    apply: 'MSCK REPAIR TABLE',
    detail: 'macro',
    info: 'MSCK REPAIR TABLE keyword for repairing table metadata',
  },
  {
    label: 'tt',
    type: 'text',
    apply: 'TRUNCATE TABLE',
    detail: 'macro',
    info: 'TRUNCATE TABLE keyword for removing all rows from a table',
  },
  {
    label: 'ii',
    type: 'text',
    apply: 'INSERT INTO',
    detail: 'macro',
    info: 'INSERT INTO keyword for inserting data into a table',
  },
  {
    label: 'io',
    type: 'text',
    apply: 'INSERT OVERWRITE',
    detail: 'macro',
    info: 'INSERT OVERWRITE keyword for overwriting data in a table',
  },
  {
    label: 'iod',
    type: 'text',
    apply: 'INSERT OVERWRITE DIRECTORY',
    detail: 'macro',
    info: 'INSERT OVERWRITE DIRECTORY keyword for overwriting data in a directory',
  },
  {
    label: 'ld',
    type: 'text',
    apply: 'LOAD DATA',
    detail: 'macro',
    info: 'LOAD DATA keyword for loading data into a table',
  },
  {
    label: 'cb',
    type: 'text',
    apply: 'CLUSTER BY',
    detail: 'macro',
    info: 'CLUSTER BY keyword for grouping data by columns',
  },
  {
    label: 'db',
    type: 'text',
    apply: 'DISTRIBUTE BY',
    detail: 'macro',
    info: 'DISTRIBUTE BY keyword for distributing data across reducers',
  },
  {
    label: 'gb',
    type: 'text',
    apply: 'GROUP BY',
    detail: 'macro',
    info: 'GROUP BY keyword for grouping rows that have the same values',
  },
  {
    label: 'it',
    type: 'text',
    apply: 'INLINE TABLE',
    detail: 'macro',
    info: 'INLINE TABLE keyword for creating an inline table',
  },
  {
    label: 'ob',
    type: 'text',
    apply: 'ORDER BY',
    detail: 'macro',
    info: 'ORDER BY keyword for sorting the result set',
  },
  {
    label: 'so',
    type: 'text',
    apply: 'SET OPERATORS',
    detail: 'macro',
    info: 'SET OPERATORS keyword for combining multiple queries',
  },
  {
    label: 'sb',
    type: 'text',
    apply: 'SORT BY',
    detail: 'macro',
    info: 'SORT BY keyword for sorting data within each reducer',
  },
  {
    label: 'wf',
    type: 'text',
    apply: 'WINDOW FUNCTION',
    detail: 'macro',
    info: 'WINDOW FUNCTION keyword for performing calculations across rows',
  },
  {
    label: 'lv',
    type: 'text',
    apply: 'LATERAL VIEW',
    detail: 'macro',
    info: 'LATERAL VIEW keyword for generating a virtual table',
  },
  {
    label: 'af',
    type: 'text',
    apply: 'ADD FILE',
    detail: 'macro',
    info: 'ADD FILE keyword for adding a file to distributed cache',
  },
  {
    label: 'aj',
    type: 'text',
    apply: 'ADD JAR',
    detail: 'macro',
    info: 'ADD JAR keyword for adding a JAR to distributed cache',
  },
  {
    label: 'atbl',
    type: 'text',
    apply: 'ANALYZE TABLE',
    detail: 'macro',
    info: 'ANALYZE TABLE keyword for analyzing table statistics',
  },
  {
    label: 'ctbl',
    type: 'text',
    apply: 'CACHE TABLE',
    detail: 'macro',
    info: 'CACHE TABLE keyword for caching a table in memory',
  },
  {
    label: 'clt',
    type: 'text',
    apply: 'CACHE LAZY TABLE',
    detail: 'macro',
    info: 'CACHE LAZY TABLE keyword for lazily caching a table',
  },
  {
    label: 'cc',
    type: 'text',
    apply: 'CLEAR CACHE',
    detail: 'macro',
    info: 'CLEAR CACHE keyword for clearing the cache',
  },
  {
    label: 'descdb',
    type: 'text',
    apply: 'DESCRIBE DATABASE',
    detail: 'macro',
    info: 'DESCRIBE DATABASE keyword for showing database metadata',
  },
  {
    label: 'ddb',
    type: 'text',
    apply: 'DESC DATABASE',
    detail: 'macro',
    info: 'DESC DATABASE keyword for showing database metadata (short form)',
  },
  {
    label: 'descf',
    type: 'text',
    apply: 'DESCRIBE FUNCTION',
    detail: 'macro',
    info: 'DESCRIBE FUNCTION keyword for showing function details',
  },
  {
    label: 'df',
    type: 'text',
    apply: 'DESC FUNCTION',
    detail: 'macro',
    info: 'DESC FUNCTION keyword for showing function details (short form)',
  },
  {
    label: 'descq',
    type: 'text',
    apply: 'DESCRIBE QUERY',
    detail: 'macro',
    info: 'DESCRIBE QUERY keyword for showing query details',
  },
  {
    label: 'dq',
    type: 'text',
    apply: 'DESC QUERY',
    detail: 'macro',
    info: 'DESC QUERY keyword for showing query details (short form)',
  },
  {
    label: 'desct',
    type: 'text',
    apply: 'DESCRIBE TABLE',
    detail: 'macro',
    info: 'DESCRIBE TABLE keyword for showing table metadata',
  },
  {
    label: 'dt',
    type: 'text',
    apply: 'DESC TABLE',
    detail: 'macro',
    info: 'DESC TABLE keyword for showing table metadata (short form)',
  },
  {
    label: 'lf',
    type: 'text',
    apply: 'LIST FILE',
    detail: 'macro',
    info: 'LIST FILE keyword for listing files in cache',
  },
  {
    label: 'lj',
    type: 'text',
    apply: 'LIST JAR',
    detail: 'macro',
    info: 'LIST JAR keyword for listing JARs in cache',
  },
  {
    label: 'rt',
    type: 'text',
    apply: 'REFRESH TABLE',
    detail: 'macro',
    info: 'REFRESH TABLE keyword for refreshing table metadata',
  },
  {
    label: 'sc',
    type: 'text',
    apply: 'SHOW COLUMNS',
    detail: 'macro',
    info: 'SHOW COLUMNS keyword for showing table columns',
  },
  {
    label: 'sct',
    type: 'text',
    apply: 'SHOW CREATE TABLE',
    detail: 'macro',
    info: 'SHOW CREATE TABLE keyword for showing table creation statement',
  },
  {
    label: 'sf',
    type: 'text',
    apply: 'SHOW FUNCTIONS',
    detail: 'macro',
    info: 'SHOW FUNCTIONS keyword for listing available functions',
  },
  {
    label: 'ssf',
    type: 'text',
    apply: 'SHOW SYSTEMFUNCTIONS',
    detail: 'macro',
    info: 'SHOW SYSTEMFUNCTIONS keyword for listing system functions',
  },
  {
    label: 'sp',
    type: 'text',
    apply: 'SHOW PARTITIONS',
    detail: 'macro',
    info: 'SHOW PARTITIONS keyword for showing table partitions',
  },
  {
    label: 'ste',
    type: 'text',
    apply: 'SHOW TABLE EXTENDED',
    detail: 'macro',
    info: 'SHOW TABLE EXTENDED keyword for showing detailed table info',
  },
  {
    label: 'st',
    type: 'text',
    apply: 'SHOW TABLES',
    detail: 'macro',
    info: 'SHOW TABLES keyword for listing all tables',
  },
  {
    label: 'stp',
    type: 'text',
    apply: 'SHOW TBLPROPERTIES',
    detail: 'macro',
    info: 'SHOW TBLPROPERTIES keyword for showing table properties',
  },
  {
    label: 'sv',
    type: 'text',
    apply: 'SHOW VIEWS',
    detail: 'macro',
    info: 'SHOW VIEWS keyword for listing all views',
  },
  {
    label: 'ut',
    type: 'text',
    apply: 'UNCACHE TABLE',
    detail: 'macro',
    info: 'UNCACHE TABLE keyword for removing a table from cache',
  },
  {
    label: 'cs',
    type: 'text',
    apply: 'COMPUTE STATISTICS',
    detail: 'macro',
    info: 'COMPUTE STATISTICS keyword for computing table statistics',
  },
  {
    label: 'csn',
    type: 'text',
    apply: 'COMPUTE STATISTICS NOSCAN',
    detail: 'macro',
    info: 'COMPUTE STATISTICS NOSCAN keyword for computing statistics without scanning',
  },
];
